import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TelemonitoringHttpService } from '@services/http/telemonitoring.http.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TelemonitoringService {
  private sanitizer = inject(DomSanitizer);
  private readonly telemonitoringService = inject(TelemonitoringHttpService);

  getQrCode(tmId: number): Observable<SafeHtml> {
    return this.telemonitoringService
      .getQrCode(tmId)
      .pipe(map((svg: string) => this.sanitizer.bypassSecurityTrustHtml(svg)));
  }
}
